/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as InviteRouteImport } from './../routes/invite'
import { Route as AppRouteImport } from './../routes/_app'
import { Route as AdminRouteImport } from './../routes/_admin'
import { Route as AppIndexRouteImport } from './../routes/_app.index'
import { Route as AppProfileRouteImport } from './../routes/_app.profile'
import { Route as AppOnboardingRouteImport } from './../routes/_app.onboarding'
import { Route as AppCheckinRouteImport } from './../routes/_app.checkin'
import { Route as AdminAdminIndexRouteImport } from './../routes/_admin.admin.index'
import { Route as AppSessionSessionIdRouteImport } from './../routes/_app.session.$sessionId'
import { Route as AppJournalSessionIdRouteImport } from './../routes/_app.journal.$sessionId'
import { Route as AppFlowFlowIdRouteImport } from './../routes/_app.flow.$flowId'
import { Route as AdminAdminUsersRouteImport } from './../routes/_admin.admin.users'
import { Route as AdminAdminClipsRouteImport } from './../routes/_admin.admin.clips'
import { Route as AdminAdminClipsClipIdRouteImport } from './../routes/_admin.admin.clips_.$clipId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckinRoute = AppCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AppRoute,
} as any)
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AdminRoute,
} as any)
const AppSessionSessionIdRoute = AppSessionSessionIdRouteImport.update({
  id: '/session/$sessionId',
  path: '/session/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppJournalSessionIdRoute = AppJournalSessionIdRouteImport.update({
  id: '/journal/$sessionId',
  path: '/journal/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppFlowFlowIdRoute = AppFlowFlowIdRouteImport.update({
  id: '/flow/$flowId',
  path: '/flow/$flowId',
  getParentRoute: () => AppRoute,
} as any)
const AdminAdminUsersRoute = AdminAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminClipsRoute = AdminAdminClipsRouteImport.update({
  id: '/admin/clips',
  path: '/admin/clips',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminClipsClipIdRoute = AdminAdminClipsClipIdRouteImport.update({
  id: '/admin/clips_/$clipId',
  path: '/admin/clips/$clipId',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/checkin': typeof AppCheckinRoute
  '/onboarding': typeof AppOnboardingRoute
  '/profile': typeof AppProfileRoute
  '/admin/clips': typeof AdminAdminClipsRoute
  '/admin/users': typeof AdminAdminUsersRoute
  '/flow/$flowId': typeof AppFlowFlowIdRoute
  '/journal/$sessionId': typeof AppJournalSessionIdRoute
  '/session/$sessionId': typeof AppSessionSessionIdRoute
  '/admin/': typeof AdminAdminIndexRoute
  '/admin/clips/$clipId': typeof AdminAdminClipsClipIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/checkin': typeof AppCheckinRoute
  '/onboarding': typeof AppOnboardingRoute
  '/profile': typeof AppProfileRoute
  '/admin/clips': typeof AdminAdminClipsRoute
  '/admin/users': typeof AdminAdminUsersRoute
  '/flow/$flowId': typeof AppFlowFlowIdRoute
  '/journal/$sessionId': typeof AppJournalSessionIdRoute
  '/session/$sessionId': typeof AppSessionSessionIdRoute
  '/admin': typeof AdminAdminIndexRoute
  '/admin/clips/$clipId': typeof AdminAdminClipsClipIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/_app/checkin': typeof AppCheckinRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/': typeof AppIndexRoute
  '/_admin/admin/clips': typeof AdminAdminClipsRoute
  '/_admin/admin/users': typeof AdminAdminUsersRoute
  '/_app/flow/$flowId': typeof AppFlowFlowIdRoute
  '/_app/journal/$sessionId': typeof AppJournalSessionIdRoute
  '/_app/session/$sessionId': typeof AppSessionSessionIdRoute
  '/_admin/admin/': typeof AdminAdminIndexRoute
  '/_admin/admin/clips_/$clipId': typeof AdminAdminClipsClipIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invite'
    | '/login'
    | '/checkin'
    | '/onboarding'
    | '/profile'
    | '/admin/clips'
    | '/admin/users'
    | '/flow/$flowId'
    | '/journal/$sessionId'
    | '/session/$sessionId'
    | '/admin/'
    | '/admin/clips/$clipId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invite'
    | '/login'
    | '/checkin'
    | '/onboarding'
    | '/profile'
    | '/admin/clips'
    | '/admin/users'
    | '/flow/$flowId'
    | '/journal/$sessionId'
    | '/session/$sessionId'
    | '/admin'
    | '/admin/clips/$clipId'
  id:
    | '__root__'
    | '/_admin'
    | '/_app'
    | '/invite'
    | '/login'
    | '/_app/checkin'
    | '/_app/onboarding'
    | '/_app/profile'
    | '/_app/'
    | '/_admin/admin/clips'
    | '/_admin/admin/users'
    | '/_app/flow/$flowId'
    | '/_app/journal/$sessionId'
    | '/_app/session/$sessionId'
    | '/_admin/admin/'
    | '/_admin/admin/clips_/$clipId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkin': {
      id: '/_app/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof AppCheckinRouteImport
      parentRoute: typeof AppRoute
    }
    '/_admin/admin/': {
      id: '/_admin/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_app/session/$sessionId': {
      id: '/_app/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof AppSessionSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journal/$sessionId': {
      id: '/_app/journal/$sessionId'
      path: '/journal/$sessionId'
      fullPath: '/journal/$sessionId'
      preLoaderRoute: typeof AppJournalSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/flow/$flowId': {
      id: '/_app/flow/$flowId'
      path: '/flow/$flowId'
      fullPath: '/flow/$flowId'
      preLoaderRoute: typeof AppFlowFlowIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_admin/admin/users': {
      id: '/_admin/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/clips': {
      id: '/_admin/admin/clips'
      path: '/admin/clips'
      fullPath: '/admin/clips'
      preLoaderRoute: typeof AdminAdminClipsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/clips_/$clipId': {
      id: '/_admin/admin/clips_/$clipId'
      path: '/admin/clips/$clipId'
      fullPath: '/admin/clips/$clipId'
      preLoaderRoute: typeof AdminAdminClipsClipIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminClipsRoute: typeof AdminAdminClipsRoute
  AdminAdminUsersRoute: typeof AdminAdminUsersRoute
  AdminAdminIndexRoute: typeof AdminAdminIndexRoute
  AdminAdminClipsClipIdRoute: typeof AdminAdminClipsClipIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminClipsRoute: AdminAdminClipsRoute,
  AdminAdminUsersRoute: AdminAdminUsersRoute,
  AdminAdminIndexRoute: AdminAdminIndexRoute,
  AdminAdminClipsClipIdRoute: AdminAdminClipsClipIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppRouteChildren {
  AppCheckinRoute: typeof AppCheckinRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
  AppFlowFlowIdRoute: typeof AppFlowFlowIdRoute
  AppJournalSessionIdRoute: typeof AppJournalSessionIdRoute
  AppSessionSessionIdRoute: typeof AppSessionSessionIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCheckinRoute: AppCheckinRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
  AppFlowFlowIdRoute: AppFlowFlowIdRoute,
  AppJournalSessionIdRoute: AppJournalSessionIdRoute,
  AppSessionSessionIdRoute: AppSessionSessionIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
